export default __webpack_public_path__ + "static/media/house1.98c3f6f5.jpeg";